import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Col, Collapse, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ApiBackendClient } from '../../helpers/api_backend_helper';
import { menuItems2 } from '../../Layouts/LayoutMenuData';

const MenuNavegacion = () => {
    const navigate = useNavigate();
    const [menuItems, setMenuItems] = useState([]);
    const tenantId = useSelector((state) => state.Context.tenantId);
    const apiClient = new ApiBackendClient();

    useEffect(() => {
        const fetchMenuData = async () => {
            if (tenantId) {
                try {
                    const response = await apiClient.get("/menu", { tenantId });
                    setMenuItems(response);
                } catch (error) {
                    console.error("Error fetching menu:", error);
                    setMenuItems(menuItems2);
                }
            } else {
                setMenuItems(menuItems2);
            }
        };
        fetchMenuData();
    }, [navigate, tenantId]);

    document.title = "Menu | Siga ERP";
    return (
        <React.Fragment>

            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Row className="row-cols-xxl-5 row-cols-lg-3 row-cols-1">
                                {menuItems && Array.isArray(menuItems) && menuItems.sort().map((item) => (
                                    <Col key={item.id}>
                                        <Card className="card-body">
                                            <div className="d-flex mb-4 align-items-center text-center">
                                                <div className="flex-grow-1 ms-2">
                                                    <h5 className="card-title mb-1">{item.label}</h5>
                                                    {item.description && <p className="text-muted mb-0">{item.description}</p>}
                                                </div>
                                            </div>
                                            <Link to={item.link} className="btn btn-primary btn-sm">Abrir</Link>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default MenuNavegacion;
